
export type TrackMetric401 = {
  error?: string;
};
